// extracted by mini-css-extract-plugin
module.exports = {"block":"_12264","group":"_768","title":"_10109","list":"_5243","item":"_6435","name":"_2003","count":"_13162","price":"_13317","dash":"_2842","highlight":"_12368"};